<template>
    <div class="container container-table">
        <div class="row">
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-solid box-info">
                        <div>
                            <div class="box-body">
                                <div class="row">
                                    <div style="width:224px;margin:auto;">
                                        <img src="../../src/assets/img/account/developer.png" class="center-block1">
                                    </div>
                                    <div style="test_all">
                                    <div class="text-center col-md-4 col-sm-offset-4 container">
                                        <form class="ui form loginForm container">
                                            <div class="mail-02"><img class="mail-02_image" src="../../src/assets/img/account/gra-account-check.jpg" alt=""></div>
                                            <div class="Youre-almost-ready">
                                                <p class="account_setup_comple">{{$t('userRolse.common.table.cell.accept.confirm')}}</p>
                                            </div>
                                        </form>
                                    </div>
                                    <LoginFooter/>
                                    <div style="display:none;">{{developerType}}</div>
                                    </div>
                                </div>

                                <br/>

                            </div>

                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>
import api from '../api'
import LoginFooter from '@/views/LoginFooter.vue'
import config from '../config'
export default {
    name: 'Login',
    components: {
        LoginFooter
    },
    data (router) {
        return {
            changeRed: false,
            disabled: true
        }
    },
    mounted () {
        // console.log(this)
        this.$store.state.isFooterShow = false
        let inviteCode = localStorage.getItem('inviteCode')
        // console.log('========' + inviteCode)
        const path =
                config.developerApiDomain + '/v1/developer/user/invite/code/verify?code=' + inviteCode
        api.request('get', path, null, null, null)
            .then(response => {
                // console.log(response)
                if (response && response.status === 200) {
                    // console.log('remove========' + inviteCode)
                    localStorage.removeItem('inviteCode')
                    localStorage.removeItem('inviteEmail')
                }
            })
        localStorage.removeItem('inviteCode')
        localStorage.removeItem('inviteEmail')
    },
    methods: {
        proceed_verify () {
            this.$router.push({ name: 'authentication' })
        },
        reds () {
            this.changeRed = true
        },
        developerTypeBtn (type) {
            // console.log(type)
            localStorage.setItem('developerType', type)
            this.$store.state.developerType = type
        }
    },
    computed: {
        developerType () {
            return this.$store.state.developerType
        }
    },
    // 使用生命周期函数 实现input框样式
    beforeUpdate () {
        // 这是在判断 是否改变登陆按钮的颜色 是否禁用登陆按钮
        if (!this.$store.state.developerType) {
            this.changeRed = false
            this.disabled = true
            this.creat_account_flag = true
            // this.error_response_flag = true
        } else {
            this.changeRed = true
            this.disabled = false
            // this.error_response_flag = false
        }
        // else if (this.password === '' || this.email === '') {
        //     this.changeRed = false
        //     this.disabled = true
        // }
    },
    destroyed () {
        this.$store.state.isFooterShow = true
        localStorage.removeItem('developerType')
        this.$store.state.developerType = null
    }
}
</script>

<style scoped>
    .email {
        width: 428px;
        height: 20px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: #00b5e2;
    }
    .emailP{
        margin-bottom: 20px!important;
    }
    .btn_login_border{
        width: 201.5px;
        height: 0.1px;
        border: solid 1.2px rgba(51, 51, 51, 0.3);
        position: absolute;
        left: 148px;
        top: 48px;
    }
    .divBtnletter{
        margin-top: 50px;
        position: relative;
        text-align: center;
    }
    .btnLetterCompeleted{
        width: 220px;
        height: 50px;
        border-radius: 10px;
        background-color: #00b5e2;
        outline: none;
        border: none;
        font-family: sans-serif;
        font-size: 22px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.2px;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
    }

    .account_email_image{
        width: 22px;
        height: 20px;
        margin-left: 4px;
        margin-right: 9px;
    }
    .Youre-almost-ready {
    width: 428px;
    font-family: sans-serif;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    color: #333333;
    margin-left: 74px;
    text-align: left;
    margin-top: 14px;
    }
     .account_setup_comple {
    font-family: sans-serif;
    font-size: 22px!important;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1.2px;
    color: #333333;
    }
    .Youre-almost-ready p{
        font-size: 14px;
        margin: 0;
    }
     .Youre-almost-ready a{
        margin-bottom: 20px;
        text-align: left;
        display: inline-block;
        color: #00b5e2;
    }
      .email_account {
        padding-top: 20px;
    }
    .div_span_border{
        position: relative;
        margin-top: 34px;
    }
    .span_border{
        width: 280px;
        height: 0.1px;
        border: solid .8px rgba(51, 51, 51, 0.3);
        position: absolute;
        left: 105px;
        bottom: 0;
    }
    .normal {
        width: 306px;
        height: 50px;
        border-radius: 10px;
        background-color: #00b5e2;
        font-family: sans-serif;
        font-size: 22px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.2px;
        text-align: center;
        color: #ffffff;
        outline: none;
        border: none;
        cursor: pointer;
    }
    .mail-02_image{
        width: 100%;
        height: 100%;
    }
    .mail-02 {
        width: 170px;
        margin: auto;
    }
    .Remember_me_image{
        width: 100%;
        height: 100%;
    }
    .div_creat_account{
        width: 30.7em;
        height: 5.57em;
        border-radius: 10px;
        background-color: rgba(255, 255, 255, 0.3);
        border: solid 2.5px rgba(0, 181, 226, 0.5);
        margin: auto;
        margin-top: 13.5em;
        margin-bottom: -20.6em;
        cursor: pointer;
    }
    .span_creat_account{
        width: 21.4em;
        height: 2.35em;
        font-family: sans-serif;
        font-size: 22px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.2px;
        text-align: center;
        color: #00b5e2;
        line-height: 3em;
    }
    .error_response_p{
        margin:0;
    }
    .input_error_response{
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: rgba(246, 70, 53, 0.5);
        margin-top: -.6em;
        padding-bottom: 0.9em;
    }
    .label_class{
          width: 1.7em;
          height: 1.8em;
          border: 1px solid #00b5e2;
          border-radius: 2px;
          margin-top: -.3em;
          cursor: pointer;
    }
    .red{
         background-color: #00b5e2!important;
         opacity: 1!important;
        }
    .btn_signin{
        width: 10em;
        height: 2.4em;
        outline: none;
        border: 2px solid #00b5e2;
        background: white;
        color:#00b5e2;
        font-size: 22px;
        cursor: pointer;
        border-radius: 10px;
        letter-spacing: 1.2px;
        font-weight: bold;
    }
    .btn_login{
        width: 10em;
        height: 2.4em;
        outline: none;
        border: 0;
        border-radius: 10px;
        font-size: 22px;
        letter-spacing: 1.2px;
        font-weight: bold;
        cursor: pointer!important;
        background-color: rgba(51, 51, 51, 0.2);
        color: #ffffff;
        opacity: 0.5;
        margin-bottom: 0;
    }
    .loading{
        font-size:18px;
    }
    .btnStyle{
        background: #00b5e2;
        color: #ffffff;
    }
    .input_border{
        border-color: #f64635!important;
        color: #f64635!important;
    }
    html, body, .container-table {
        height: 100%;
        background-color: white !important;
    }
    .container-table {
        display: table;
        color: white;
        width:72%;
    }
    .vertical-center-row {
        display: table-cell;
        vertical-align: middle;
    }
    .vertical-20p {
        padding-top: 20%;
    }
    .vertical-10p {
        padding-top: 10%;
    }
    .logo {
        width: 15em;
        padding: 3em;
    }
    .loginForm .input-group {
        padding-bottom: 1em;
        height: 0;
    }
    .input-group input {
        height: 2.7em;
    }
    #userLoginSubmitButton {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
        height: 100%;
        outline: none;
    }
    /* [fu] */

    /* 取消边框 */
    .box.box-solid.box-info{
        border:none;
    }
    .vertical-10p{
       padding-top: 3.5em!important;
    }
    .center-block1 {
       padding-bottom: 3.5em!important;
       margin-top: 50px;
    }
    .box-body{
        padding-top: 0;
    }
    /* input */
    .input-group input{
        width: 23.8em!important;
        border-radius: 12px!important;
        border: 1px solid rgba(51,51,51,0.5);
        color: #333333;
    }
    .input-group{
        margin: auto;
        font-weight: bold;
    }
    /* form剧中 */
    .col-sm-offset-4{
         margin: auto;
         width: 100%;
    }
    .checkbox_div{
        display: flex;
        margin-left: 2em;
        margin-bottom: 3.5em;
        width: 23.8em;
        margin: auto;
        padding-bottom: 2.8em;
        margin-top: .3em;
        position: relative;
    }
    /* 这是button */
    .btn-info{
       background-color: rgba(51,51,51,0.2);
        border: none;
        width: 10em!important;
        margin-left: 33%;
        border-radius: 8px!important;
        font-size: 22px!important;
        height: 50px!important;
        margin-bottom: 1.5em!important;
        margin:auto;
    }
    .div_signin{
        width: 37em;
        padding-top:2.4em;
        margin: auto;
    }

    /* input的字体大小 */
    .form-control{
        padding: 6px 24px;
        font-size: 18px;
    }
    .Forget_password{
        height: 20px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: #333333;
    }
    .Remember_me{
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: 19px;
        letter-spacing: 0.8px;
        color: #333333;
        padding-left: 10px;
    }
    .Remember_me{
        cursor: pointer;
    }
    .checkbox_class{
        cursor: pointer;
    }
    .Forget_password{
        cursor: pointer;
    }
    /* 加form的上下border */
    .ui{
        width: 31em;
        border-bottom: none;
        border-top: 2px solid rgba(51, 51, 51, 0.1);
        padding-top: 5px;
        padding-bottom: 0;
        }
    .box{
        box-shadow: none;
        margin-bottom: 0;
    }
    .box-body{
        padding-bottom: 0;
    }
    .Join-NUWA-developer{
        width: 164px;
        height: 20px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: rgba(51, 51, 51, 0.5);
        margin: auto;
        padding-top: 2.7em;
    }

    /* 底部 */
    .Copyright-2018-Nuw{
        width: 400px;
        height: 20px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        margin-left: 1em;
        color: #333333;
    }
    .copyright_a{
        color: #333333;
    }
    .Login-Page_Link{
        height: 20px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: #333333;
    }
    .Login-Page_Link a{
        padding: 0 18px;
        color: #333333;
    }
    .Login-Page_Link a:not(:last-child){
        border-right: 1px solid;
    }
    .input_form{
        width: 380px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.2px;
        color: rgba(51, 51, 51, 0.3);
    }
    .div_footer{
        display:flex;
        clear:both;
        margin:auto;
        padding-top: 25.5em;
        width: 57em;
    }
    #app{
        background: rgba(0, 181, 226, 0.1);
    }

    /* [新增] */
    .container {
        margin: auto;
    }
    .label_class{
        width: 21.8px;
        height: 23.2px;
    }
    .input-group {
        position: relative;
        display: table;
        border-collapse: separate;
    }
    .btn_signin{
        display: block;
        margin: auto;
    }
    .Join-NUWA-developer{
        text-align: center;
    }
    .input-group input{
        outline: none;
        height: 1.7em!important;
        width: 20.2em!important
    }
    .checkbox_div{
        width: 20.2em!important;
    }
    /* 新增 */
</style>
